import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import axios from "axios";
import { UserRoleOptions } from "../constants/userRole";
import { SyncLoader } from "react-spinners";
import FacebookAuthModal from "../component/models/FacebookAuthModal";

const title = "Register Now";

const SignInPage = () => {
  const [formData, setFormData] = useState({
    regName: "",
    regUsername: "",
    regAge: "",
    regPassword: "",
    regConPassword: "",
    regRole: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [focusField, setFocusField] = useState(null);
  const [isFbModalOpen, setIsFbModalOpen] = useState(false);

  const navigate = useNavigate();

  const inputRefs = {
    regName: useRef(null),
    regUsername: useRef(null),
    regAge: useRef(null),
    regPassword: useRef(null),
    regConPassword: useRef(null),
    regRole: useRef(null),
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setFocusField(null);
  };

  const setErrorField = (message, field) => {
    setError(message);
    setFocusField(field);
    inputRefs[field]?.current?.focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      regName,
      regUsername,
      regAge,
      regPassword,
      regConPassword,
      regRole,
    } = formData;

    if (!regName) return setErrorField("Name is required", "regName");
    if (!regUsername)
      return setErrorField("Email or phone number is required", "regUsername");

    // Validate email or phone
    let email = null;
    let phone = null;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10,}$/;

    if (emailRegex.test(regUsername)) {
      email = regUsername;
    } else if (phoneRegex.test(regUsername)) {
      phone = regUsername;
    } else {
      return setErrorField(
        "Please enter a valid email or phone number",
        "regUsername"
      );
    }

    if (!regRole) return setErrorField("Role is required", "regRole");
    if (!regAge) return setErrorField("Age is required", "regAge");
    if (!regPassword)
      return setErrorField("Password is required", "regPassword");
    if (regPassword.length < 8)
      return setErrorField(
        "Password must be at least 8 characters",
        "regPassword"
      );
    if (regPassword !== regConPassword)
      return setErrorField("Passwords do not match", "regConPassword");

    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/register`,
        {
          name: regName,
          email,
          phone,
          age: regAge,
          role: regRole,
          password: regPassword,
          password_confirmation: regConPassword,
        }
      );

      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("user_id", response.data.data.user_id);

      navigate("/post", {
        state: { userId: response.data.data.user_id },
      });
    } catch (err) {
      let errorMessage = "Registration failed. Please try again.";
      if (err.response) {
        errorMessage =
          err.response.data.message ||
          (err.response.data.errors
            ? Object.values(err.response.data.errors).join(" ")
            : "Registration failed");
      } else if (err.request) {
        errorMessage = "No response from server. Please check your connection.";
      }
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <PageHeader title="Sign Up" />

      {/* 🔹 Full Screen Loader Overlay */}
      {loading && (
        <div className="fullscreen-loader">
          <SyncLoader size={12} color="#DF314D" />
        </div>
      )}


      <div className="login-section padding-tb">
        <div className="container">
          <div className="account-wrapper">
            <h3 className="title">{title}</h3>

            <div style={{
              backgroundColor: '#e7f3ff',
              border: '1px solid #1877f2',
              borderRadius: '8px',
              padding: '25px 20px',
              marginBottom: '30px',
              textAlign: 'center',
              boxShadow: '0 4px 15px rgba(24, 119, 242, 0.15)'
            }}>
              <h4 style={{ color: '#1877f2', marginBottom: '10px', fontSize: '22px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <i className="icofont-shield-check"></i>
                Keep Your Privacy Safe
              </h4>
              <p style={{ color: '#606770', fontSize: '15px', marginBottom: '20px', lineHeight: '1.5' }}>
                Use Facebook Login for quick, secure, and private access. We never post without your permission.
              </p>
              <button 
                type="button" 
                onClick={() => setIsFbModalOpen(true)}
                style={{
                  backgroundColor: '#1877f2', color: 'white', width: '100%', 
                  padding: '14px', borderRadius: '8px', border: 'none', 
                  fontSize: '18px', fontWeight: 'bold', display: 'flex', 
                  alignItems: 'center', justifyContent: 'center', gap: '12px',
                  cursor: 'pointer', transition: 'all 0.3s ease',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#166fe5';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 12px rgba(24, 119, 242, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = '#1877f2';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                }}
              >
                <i className="icofont-facebook" style={{fontSize: '26px'}}></i> Continue with Facebook
              </button>
            </div>
            
            <div style={{ textAlign: 'center', marginBottom: '30px', position: 'relative' }}>
              <hr style={{ borderTop: '1px solid #e0e0e0', margin: 0 }} />
              <span style={{ 
                position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', 
                backgroundColor: '#fff', padding: '0 20px', color: '#888', fontSize: '14px', fontWeight: '600', letterSpacing: '1px' 
              }}>OR</span>
            </div>

            {error && (
              <div style={{ color: "red", marginBottom: 10 }}>{error}</div>
            )}

            <form className="account-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  ref={inputRefs.regName}
                  type="text"
                  name="regName"
                  value={formData.regName}
                  onChange={handleInputChange}
                  placeholder="Your Name *"
                  className={focusField === "regName" ? "input-error" : ""}
                />
              </div>

              <div className="form-group">
                <input
                  ref={inputRefs.regUsername}
                  type="text"
                  name="regUsername"
                  value={formData.regUsername}
                  onChange={handleInputChange}
                  placeholder="Email or Phone Number *"
                  className={focusField === "regUsername" ? "input-error" : ""}
                />
              </div>

              <div className="form-group">
                <input
                  ref={inputRefs.regAge}
                  type="number"
                  min="1"
                  max="120"
                  name="regAge"
                  value={formData.regAge}
                  onChange={handleInputChange}
                  placeholder="Age *"
                  className={focusField === "regAge" ? "input-error" : ""}
                />
              </div>

              <div className="form-group">
                <select
                  ref={inputRefs.regRole}
                  name="regRole"
                  value={formData.regRole}
                  onChange={handleInputChange}
                  className={`select-category ${
                    focusField === "regRole" ? "input-error" : ""
                  }`}
                >
                  <option value="">Select Your Category *</option>
                  {UserRoleOptions.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <input
                  ref={inputRefs.regPassword}
                  type="password"
                  name="regPassword"
                  value={formData.regPassword}
                  onChange={handleInputChange}
                  placeholder="Password *"
                  className={focusField === "regPassword" ? "input-error" : ""}
                />
              </div>

              <div className="form-group">
                <input
                  ref={inputRefs.regConPassword}
                  type="password"
                  name="regConPassword"
                  value={formData.regConPassword}
                  onChange={handleInputChange}
                  placeholder="Confirm Password *"
                  className={
                    focusField === "regConPassword" ? "input-error" : ""
                  }
                />
              </div>

              <div className="form-group">
                <button
                  className="d-block lab-btn"
                  type="submit"
                  disabled={loading}
                >
                  <span>{loading ? "Registering..." : "Get Started Now"}</span>
                </button>
              </div>
            </form>

            <div className="account-bottom">
              <span className="d-block cate pt-10">
                Are you a member? <Link to="/login">Login</Link>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <FacebookAuthModal isOpen={isFbModalOpen} onClose={() => setIsFbModalOpen(false)} />
      
      <FooterSection />
    </div>
  );
};

export default SignInPage;
